import { render, staticRenderFns } from "./subcategoria1_screen.vue?vue&type=template&id=2f0e7f87"
import script from "./subcategoria1_screen.vue?vue&type=script&lang=js"
export * from "./subcategoria1_screen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports